function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _sortBy from 'lodash/sortBy';
import { translate } from './helpers';

var Form = /*#__PURE__*/function (_Component) {
  _inherits(Form, _Component);

  var _super = _createSuper(Form);

  function Form(props) {
    var _this;

    _classCallCheck(this, Form);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "validateField", function (fieldName, value) {
      var fields = _this.props.fields.map(function (field) {
        if (field.needValidation === false || field.name !== fieldName) {
          return field;
        } else {
          if (field.type === 'email') {
            field.valid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) ? true : false;
            field.error = field.valid ? '' : translate("".concat(field.placeholder, " field is incorrect."), "Le champ ".concat(field.placeholder, " est incorrect."));
          } else {
            field.valid = value.length >= 1;
            field.error = field.valid ? '' : translate("".concat(field.placeholder, " field is required."), "Le champ ".concat(field.placeholder, " est requis."));
          }

          if (!field.valid) {
            _this.invalidCount += 1;
          }

          return field;
        }
      });

      _this.props.setParentState(fields, true);
    });

    _defineProperty(_assertThisInitialized(_this), "isFormValid", function () {
      _this.invalidCount = 0;

      _this.props.fields.map(function (field) {
        _this.validateField(field.name, field.value);
      });

      return _this.invalidCount === 0;
    });

    _defineProperty(_assertThisInitialized(_this), "handleUserInput", function (e) {
      var fields = _this.props.fields.map(function (field) {
        if (field.name !== e.target.name) {
          return field;
        }

        return _objectSpread(_objectSpread({}, field), {}, {
          value: e.target.value
        });
      });

      _this.props.setParentState(fields);
    });

    _defineProperty(_assertThisInitialized(_this), "handleUserSelect", function (e) {
      var select = _this.props.fields.map(function (field) {
        if (field.name !== e.target.name) {
          return field;
        }

        return _objectSpread(_objectSpread({}, field), {}, {
          value: e.target.value
        });
      });

      _this.props.setParentState(select);
    });

    _defineProperty(_assertThisInitialized(_this), "handleUserCheckbox", function (e) {
      var checkboxes = _this.props.fields.map(function (field) {
        if (field.name !== e.target.name) {
          return field;
        }

        return _objectSpread(_objectSpread({}, field), {}, {
          value: !field.value
        });
      });

      _this.props.setParentState(checkboxes);
    });

    _defineProperty(_assertThisInitialized(_this), "isValidField", function (field) {
      return field.valid || field.error === '' ? 'valid' : 'invalid';
    });

    _this.invalidCount = 0;
    return _this;
  }

  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return this.props.fields.map(function (field) {
        return field.type === 'checkbox' ? /*#__PURE__*/React.createElement("div", {
          className: "custom-control solid-checkbox",
          key: field.name
        }, /*#__PURE__*/React.createElement("div", {
          className: "checkbox-line"
        }, /*#__PURE__*/React.createElement("input", {
          className: "custom-control-input main-bg-before",
          name: field.name,
          id: field.name // onClick={this.validateCheckbox}
          // onClick={event => this.validateField(event)}
          ,
          onChange: function onChange(event) {
            return _this2.handleUserCheckbox(event);
          },
          placeholder: field.placeholder.toUpperCase(),
          type: field.type,
          checked: field.value ? 'checked' : ''
        }), /*#__PURE__*/React.createElement("label", {
          className: "custom-control-label first-uppercase",
          htmlFor: field.name
        }, field.placeholder))) : field.type === 'select' ? /*#__PURE__*/React.createElement("select", {
          className: "second-bg",
          key: field.name,
          name: field.name,
          onChange: function onChange(event) {
            return _this2.handleUserSelect(event);
          }
        }, _sortBy(_this2.props.provinces).map(function (province) {
          return /*#__PURE__*/React.createElement("option", {
            className: "province-option",
            key: province,
            value: province
          }, province.toUpperCase());
        })) : /*#__PURE__*/React.createElement("input", {
          className: "input-line-catalogue second-bg ".concat(_this2.isValidField(field)),
          key: field.name,
          name: field.name,
          onBlur: function onBlur(e) {
            return _this2.validateField(e.target.name, e.target.value);
          },
          onChange: function onChange(event) {
            return _this2.handleUserInput(event);
          },
          placeholder: field.placeholder.toUpperCase(),
          type: field.type,
          defaultValue: field.value
        });
      });
    }
  }]);

  return Form;
}(Component);

Form.propTypes = {
  fields: PropTypes.array,
  provinces: PropTypes.array,
  setParentState: PropTypes.func
};
export default Form;